// libs
import React, { useCallback } from 'react';

import { cn } from '@lyearn/style';
import Loader from '@/components/Loader';
import { hideImageSeparator } from '@/modules/corporate/modules/channel/views/ChannelDetails/components/MessageInput/styles';

import * as Editor from './components/Editor';
// types
import { PlainEditorProps } from './types';

function PlainEditor(props: PlainEditorProps) {
  const {
    value,
    onChangeText,
    placeholder,
    variant = 'body-short-02',
    color = 'text-text-primary',
    className,
    classes,
    medias = [],
    onChangeMedias,
    charLimit,
    editorOptions,
    editorOptionMap,
    editorCoreClasses,
    editorProps,
    disableSelection = false,
    showEditor = true,
    showToolbar = true,
    children,
    disabled,
    hideToolbarDivider,
    attachmentPosition = 'bottom',
  } = props;

  const renderAttachments = useCallback(() => {
    return medias.length > 0 ? <Editor.AttachmentContainer disabled={disabled} /> : null;
  }, [disabled, medias.length]);

  return (
    <React.Suspense fallback={<Loader />}>
      <Editor.Main
        charLimit={charLimit}
        className={cn(
          'relative flex flex-col overflow-hidden border focus-within:border-focus-primary',
          hideImageSeparator,
          className,
        )}
        disabled={disabled}
        medias={medias}
        placeholder={placeholder}
        value={value}
        onChangeMedias={onChangeMedias}
        onChangeText={onChangeText}
        {...editorProps}>
        {attachmentPosition === 'top' ? renderAttachments() : null}
        <Editor.EditorCore
          className={cn(classes?.editor, 'flex-1 overflow-y-auto overscroll-y-contain')}
          classes={editorCoreClasses}
          color={color}
          disableSelection={disabled || disableSelection}
          showEditor={showEditor}
          variant={variant}>
          {children}
        </Editor.EditorCore>
        {attachmentPosition === 'bottom' ? renderAttachments() : null}
        {showToolbar ? (
          <Editor.Toolbar
            classes={classes?.toolbar}
            disabled={disabled}
            editorOptionMap={editorOptionMap}
            editorOptions={editorOptions}
            hideDivider={hideToolbarDivider}
            isMedia={!!onChangeMedias}
          />
        ) : null}
      </Editor.Main>
    </React.Suspense>
  );
}

export default React.memo(PlainEditor);
